
import { type ProjectLocation } from './types';
import * as THREE from 'three';

export class CoordinateSystemManager {
    private locations: Map<string, ProjectLocation> = new Map();
    private activeLocationId: string = 'default';

    // Default Site Info
    private surveyPoint: THREE.Vector3 = new THREE.Vector3(0, 0, 0);
    private projectBasePoint: THREE.Vector3 = new THREE.Vector3(0, 0, 0);
    private angleToTrueNorth: number = 0; // Degrees

    constructor() {
        // Create default location
        this.locations.set('default', {
            id: 'default',
            name: 'Internal',
            siteId: 'site-1',
            transform: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        });
    }

    public setProjectBasePoint(x: number, y: number, z: number, angleNorth: number): void {
        this.projectBasePoint.set(x, y, z);
        this.angleToTrueNorth = angleNorth;
    }

    public getProjectBasePoint(): { position: THREE.Vector3; angleNorth: number } {
        return { position: this.projectBasePoint.clone(), angleNorth: this.angleToTrueNorth };
    }

    public transformToSharedCoordinates(point: THREE.Vector3): THREE.Vector3 {
        // Shared = Internal - BasePoint (Rotated)
        // Check BIM logic: Shared coordinates usually implied by Site Link.
        // Simplified: Apply translation and rotation.

        const rel = point.clone().sub(this.projectBasePoint);
        const axis = new THREE.Vector3(0, 0, 1);
        rel.applyAxisAngle(axis, -this.angleToTrueNorth * (Math.PI / 180));
        return rel.add(this.surveyPoint);
    }
}
